import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetErrorRequest as resetAuth } from '../redux/auth/actions';
import { resetErrorRequest as resetVehicles } from '../redux/vehicles/actions';
import { useLocation } from 'react-router-dom';


const ErrorReset = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        // Reset error whenever the route changes
        dispatch(resetAuth());
        dispatch(resetVehicles());
    }, [dispatch, location]);

    return null; // This component doesn't render anything
};

export default ErrorReset;
